import React, { useEffect, useState } from "react";
import { post } from "../../assets/Images/ImagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { ShimmerDiv } from "shimmer-effects-react";
import ModalForGuest from "../ModalForGuest";

const Medias = ({ uid, getUserProfileStat }) => {
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");

  //************************ Follower  List   ************************/
  const [isError, setIsError] = useState(false);
  const [page, setPage] = useState(1);
  const [FollowerList, setFollowerList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  console.log("FollowerList", FollowerList);
  const [nextBatchLoading, setNextBatchLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);

  const handleInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        // setLoading(true);
        setPage((prev) => prev + 1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, []);
  //************************Follower List ************************//
  //************************ Follow User Start  ************************//
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //************************ Follow User End  ************************//
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showModal]);

  const [followModal, setFollowModal] = useState(false);
  const closeModalData = () => {
    setFollowModal(false);
  };

  return (
    <>
      {!isLoading ? (
        <div className="mt-3">
          {/* <ShimmerThumbnail height={250} rounded /> */}
          <ShimmerDiv mode="light" height={250} width={"100%"} />
        </div>
      ) : isError ? (
        <div className="mt-2 text-center">
          <img src={post.errorSmall} alt="404 Not Found" width={200} />
        </div>
      ) : (
        <div className="aboutMe mb-3 p-3 MediaAllContent">
          {/* // START DESIGN FROM HEREE */}
          {/* <div className="Activities_Heading">
            <h2>Media</h2>
          </div> */}
          <ul class="nav mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="Photostab-tab"
                data-bs-toggle="pill"
                data-bs-target="#Photostab"
                type="button"
                role="tab"
                aria-controls="Photostab"
                aria-selected="true"
              >
                Photos
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="Videotab-tab"
                data-bs-toggle="pill"
                data-bs-target="#Videotab"
                type="button"
                role="tab"
                aria-controls="Videotab"
                aria-selected="false"
              >
                Video
              </button>
            </li>
          </ul>
          <div class="tab-content" id="pills-tabContent">
            <div
              class="tab-pane show active"
              id="Photostab"
              role="tabpanel"
              aria-labelledby="Photostab-tab"
            >
              <div className="row row-gap-3">
                <div className="col-lg-6 col-md-6">
                  <div className="TabPhotoMaindiv">
                    <img src="../../../assets/img/about/1.jpg" alt="" />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="TabPhotoMaindiv">
                    <img src="../../../assets/img/about/2.jpg" alt="" />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="TabPhotoMaindiv">
                    <img src="../../../assets/img/about/3.jpg" alt="" />
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="TabPhotoMaindiv">
                    <img src="../../../assets/img/about/4.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane"
              id="Videotab"
              role="tabpanel"
              aria-labelledby="Videotab-tab"
            >
              <div className="row row-gap-3">
                <div className="col-lg-6 col-md-6">
                  <div className="TabPhotoMaindiv">
                    {/* <iframe
                    
                      src="https://www.youtube.com/embed/Q-icS7yZz5k"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe> */}
                    <video
                      width="640"
                      height="360"
                      controls
                      autoPlay
                      muted
                      loop
                    >
                      <source
                        src="/path-to-your-video/video.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="TabPhotoMaindiv">
                    {/* <iframe
                    
                      src="https://www.youtube.com/watch?v=FMA79Lnzefc"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe> */}
                    <video
                      width="640"
                      height="360"
                      controls
                      autoPlay
                      muted
                      loop
                    >
                      <source
                        src="/path-to-your-video/video.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="TabPhotoMaindiv">
                    {/* <iframe
                    
                      src="https://www.youtube.com/embed/Q-icS7yZz5k"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe> */}
                    <video
                      width="640"
                      height="360"
                      controls
                      autoPlay
                      muted
                      loop
                    >
                      <source
                        src="/path-to-your-video/video.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="TabPhotoMaindiv">
                    {/* <iframe
                    
                      src="https://www.youtube.com/watch?v=FMA79Lnzefc"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe> */}
                    <video
                      width="640"
                      height="360"
                      controls
                      autoPlay
                      muted
                      loop
                    >
                      <source
                        src="/path-to-your-video/video.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {hasMoreData ? "" : <p className="text-center">No more data available</p>}
      {nextBatchLoading && (
        <div className="text-center mb-4">
          <img src={post?.loader} width={50} />
        </div>
      )} */}

      {followModal && <ModalForGuest closeModalData={closeModalData} />}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default Medias;
